import { createSlice } from "@reduxjs/toolkit";

export const ProjectEditMessageSlice = createSlice({
    name : 'project_edit_message_slice',
    initialState : {
        value:{editProjectSubmitStatus:false,ownerStatus:false,message:""}
    },
    reducers : {
        updateProjectEditMessage: (state, action) => {
            state.value = action?.payload;
        }
    }
});

export const { updateProjectEditMessage } = ProjectEditMessageSlice.actions

export default ProjectEditMessageSlice.reducer